var $ = require("jquery");
window.jQuery = $;
require("@fancyapps/fancybox");

(function ($, window) {
	
	$(function () {

		$(".editor").find("a:has(img)").addClass('group');
		$(".editor").find("a:has(img)").attr('rel','group1');
		$("a.group:not(.no-fancybox)").fancybox(
			{
				'transitionIn':'elastic',
				'transitionOut':'elastic',
				'speedIn':400,
				'speedOut':200,
				'overlayShow':false
			}
		);
		
		$(".section__has-video").on('click', function() { 
			let video_url = $(this).data('video-url');
			$.fancybox.open($({
				src  : video_url,
				'transitionIn':'elastic',
				'transitionOut':'elastic',
				'speedIn':400,
				'speedOut':200,
				'overlayShow':false,
				youtube : {
					controls : 1,
					showinfo : 1
				},
			}));
		});
		
	});
})(jQuery, window);